/**
 * @generated SignedSource<<c5865b53321c81be24e7dc79939f077e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MeetingPhaseContext_StopMeetingRecordingMutation$variables = {
  noteId: string;
};
export type MeetingPhaseContext_StopMeetingRecordingMutation$data = {
  readonly stopMeetingRecording: {
    readonly note: {
      readonly hasMeetingRecordings: boolean;
      readonly id: string;
      readonly meetingRecordings: ReadonlyArray<{
        readonly id: string;
        readonly isCurrentlyRecording: boolean | null;
      }> | null;
    };
  } | null;
};
export type MeetingPhaseContext_StopMeetingRecordingMutation = {
  response: MeetingPhaseContext_StopMeetingRecordingMutation$data;
  variables: MeetingPhaseContext_StopMeetingRecordingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "noteId",
        "variableName": "noteId"
      }
    ],
    "concreteType": "StopMeetingRecording",
    "kind": "LinkedField",
    "name": "stopMeetingRecording",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Note",
        "kind": "LinkedField",
        "name": "note",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasMeetingRecordings",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingRecording",
            "kind": "LinkedField",
            "name": "meetingRecordings",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isCurrentlyRecording",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MeetingPhaseContext_StopMeetingRecordingMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MeetingPhaseContext_StopMeetingRecordingMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "ad65252ad94a45beac2887fbf86f382f",
    "id": null,
    "metadata": {},
    "name": "MeetingPhaseContext_StopMeetingRecordingMutation",
    "operationKind": "mutation",
    "text": "mutation MeetingPhaseContext_StopMeetingRecordingMutation(\n  $noteId: ID!\n) {\n  stopMeetingRecording(noteId: $noteId) {\n    note {\n      id\n      hasMeetingRecordings\n      meetingRecordings {\n        id\n        isCurrentlyRecording\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "77b6fa8824ce29dbabf1b6341b4eff3e";

export default node;
